// extracted by mini-css-extract-plugin
export default {"shadowed":"Home_shadowed__Wp4U5","wrapperInfo":"Home_wrapperInfo__fOKQx","hand":"Home_hand__5F-qJ","wave":"Home_wave__eVles"};